import { render, staticRenderFns } from "./InstallmentBatchTypeInfo.vue?vue&type=template&id=b24366e6&"
import script from "./InstallmentBatchTypeInfo.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports